<ejs-dialog
  target=".dialogs"
  class="simple-dialog"
  [visible]="visible()"
  [animationSettings]="dialogService.getAnimationSettings()"
  [resizeHandles]="dialogService.getResizeHandleDirection()"
  [position]="dialogService.getPosition()"
  [isModal]="true"
  [allowDragging]="false"
  [width]="'420px'"
  [height]="'55vh'"
  [zIndex]="9999"
  [showCloseIcon]="true"
  [header]="header"
  [content]="content"
  (close)="closeDialog()"
>
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="('CHATEMOJILISTTITLE' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="emoji-pill-dialog-list custom-scrollbar overflow-y-auto p-2">
      @for (reaction of sortedEmojis(); track reaction.referenceId + '-' + reaction.userId + '-' + reaction.emoji + '-' + $index) {
        <div class="emoji-pill-dialog-row d-flex align-items-center gap-2 p-2">
          <span class="emoji-pill-dialog-emoji">{{ reaction.emoji }}</span>
          <app-content [fontSize]="'fs-small'" [class]="'text-muted flex-grow-1'">{{ reaction.userName }}</app-content>
          <div class="emoji-pill-dialog-action ms-auto d-flex align-items-center justify-content-end">
            @if (isOwnReaction(reaction)) {
              <app-tooltip [text]="('CHATEMOJICDELETE' | translate)" [type]="'Default'" [width]="'auto'" [height]="'auto'">
                <app-form-button
                  [style]="'btn'"
                  [cssClass]="'btn-link p-1 text-muted'"
                  [icon]="'delete'"
                  [iconClass]="'fs-5'"
                  (click)="removeReaction($event, reaction.referenceId)"
                >
                </app-form-button>
              </app-tooltip>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
</ejs-dialog>
